// Global host for AiCreditsModal — listens for the
// `makercut:ai-quota-exceeded` CustomEvent (emitted from lib/api.js whenever
// any AI route returns 429 ai_quota_exceeded) and auto-opens the credits
// modal. Mount once at the App root.
//
// Also exposes a manual trigger:
//    window.dispatchEvent(new CustomEvent('makercut:open-ai-credits'))
// so other UI (e.g. the AiCreditsBadge "+" button, "Buy credits" CTA in a
// usage page, etc.) can pop the modal without prop-drilling.

import React, { useEffect, useState } from 'react';
import AiCreditsModal from './AiCreditsModal';

export default function AiCreditsModalHost({ lang }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onQuota = () => setOpen(true);
    const onOpen = () => setOpen(true);
    window.addEventListener('makercut:ai-quota-exceeded', onQuota);
    window.addEventListener('makercut:open-ai-credits', onOpen);
    return () => {
      window.removeEventListener('makercut:ai-quota-exceeded', onQuota);
      window.removeEventListener('makercut:open-ai-credits', onOpen);
    };
  }, []);

  return (
    <AiCreditsModal
      open={open}
      onClose={() => setOpen(false)}
      lang={lang}
    />
  );
}
